import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
/**
 * An immutable snapshot of an article's title and body, taken each time the
 * article is edited. Revisions are read-only history.
 */
export default class WikiRevision extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "title", Model.attribute('title'));
    _defineProperty(this, "content", Model.attribute('content'));
    _defineProperty(this, "contentHtml", Model.attribute('contentHtml'));
    _defineProperty(this, "summary", Model.attribute('summary'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "user", Model.hasOne('user'));
    _defineProperty(this, "article", Model.hasOne('article'));
  }
}
flarum.reg.add('linkrobins-wiki', 'common/models/WikiRevision', WikiRevision);